import { useSelector } from "react-redux";
import AdminBlogPageComponent from "./components/AdminBlogPageComponent";
import { Row, Col, Modal, Tabs, Tab, OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import AdminLinksComponent from "../../components/admin/AdminLinksComponent";

const AdminBlogPage = () => {
  const { userInfo } = useSelector((state) => state.userRegisterLogin);

  return (
    <>
      <Row className="content-container m-5">
        <Col md={2}>
          <AdminLinksComponent />
        </Col>
        <Col md={10}>
          <div className="p-4">
            <h2>Admin Blogs Dashboard</h2>
            <AdminBlogPageComponent userInfo={userInfo} />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default AdminBlogPage;
